"use strict";
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const Spark = (props) => {
  const { className, size = IconSize.Medium, color = "inherit", ...rest } = props;
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    { width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass, ...rest },
    /* @__PURE__ */ React.createElement("path", { d: "m17.758 8.958-.846-1.968-2.048-.906 2.048-.886.846-1.87.847 1.87 2.047.886-2.047.906-.847 1.968Zm0 11.714-.846-1.89-2.048-.886 2.048-.886.846-1.988.847 1.988 2.047.886-2.047.886-.847 1.89ZM9.116 17.64l-1.811-3.878-3.957-1.772 3.957-1.772 1.81-3.858 1.832 3.858 3.937 1.772-3.937 1.772-1.831 3.878Z" })
  );
};
export default Spark;
